import { DateTime } from 'luxon';

import { TimeOption } from './types';

export const INTERVAL_MINUTES = 15;
const MINUTES_IN_DAY = 24 * 60;

export function generateTimeSlots(
  date: Date,
  timeZone?: string,
  preserveTime?: Date | null
): TimeOption[] {
  const now = timeZone ? DateTime.now().setZone(timeZone) : DateTime.now();
  const todayStart = now.startOf('day');

  const dateInZone = timeZone
    ? DateTime.fromJSDate(date).setZone(timeZone)
    : DateTime.fromJSDate(date);
  const startOfDay = dateInZone.startOf('day');

  const isToday = startOfDay.hasSame(todayStart, 'day');

  const slots: TimeOption[] = [];
  const totalSlots = MINUTES_IN_DAY / INTERVAL_MINUTES;
  const preserveTimeMs = preserveTime?.getTime();

  for (let i = 0; i < totalSlots; i++) {
    const slotTime = startOfDay.plus({ minutes: INTERVAL_MINUTES * i });
    const slotTimeMs = slotTime.toMillis();
    const isPastSlot = isToday && slotTime < now;
    const isPreservedSlot = preserveTimeMs && slotTimeMs === preserveTimeMs;

    if (isPastSlot && !isPreservedSlot) {
      continue;
    }

    slots.push({ date: slotTime.toJSDate() });
  }

  return slots;
}

export function getValidInitialTime(
  parsedDate: Date | null,
  timeZone?: string
): Date | null {
  if (!parsedDate) return null;

  const slots = generateTimeSlots(parsedDate, timeZone, parsedDate);
  const isValid = slots.some(
    slot => slot.date.getTime() === parsedDate.getTime()
  );

  return isValid ? parsedDate : null;
}
